// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__F91k0","header":"PatientBlock_header__10cvz","label":"PatientBlock_label__1Mu_7","option":"PatientBlock_option__b6YTr"};